<template>
  <div class="public-welfare-content">
    <div class="title">
      <h3>暖峰行动捐助地图</h3>
      <div class="tip">张雪峰老师和峰学未来的老师们用爱心点亮城市</div>
    </div>
    <public-china-map></public-china-map>
  </div>
</template>

<script>
import PublicChinaMap from "@/components/PublicChinaMap"
export default {
  name: "PublicWelfareMap",
  components: {
    PublicChinaMap
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.fxwljy.com/attach/file1706509868982.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.fxwljy.com/attach/file1706509868791.otf');
}
.public-welfare-content{
  width: 100%;
  padding-top: 120px;
  max-height: 1080px;
  height: 1080px;
  background: #F5F7FA;
  margin: 0 auto;
  .title{
    width: 100%;
    text-align: center;
    h3{
      width: 100%;
      /*height: 40px;*/
      font-size: 40px;
      font-family: 'SourceHanSansCNBold Microsoft YaHei';
      font-weight: bold;
      color: #0A0D0F;
      line-height: 60px;
    }
    .tip{
      width: 100%;
      height: 16px;
      font-size: 20px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #909295;
      line-height: 24px;
      margin-top: 36px;
    }
  }
  .mapContainer{
    width: 100%;
    height: 800px;
    padding-top: 60px;
  }
}
</style>